import RootState from 'ducks/RootState';
import isEmpty from 'lodash/isEmpty';

export const getActiveInAppIntegrationNames = (state: RootState) => {
  const integrations = state.inAppIntegrations;
  const activeIntegrations: Array<string> = [];
  Object.keys(integrations).forEach((key) => {
    if (!isEmpty(integrations[key])) {
      activeIntegrations.push(key);
    }
  });

  return activeIntegrations;
};
